<template>
  <div>
    <r-title class="title">{{ $t('login') }}</r-title>
    <login-form @success="onSuccessLogin" />
    <login-method-separator :text="$t('social.method.separator.login')" />
    <o-auth @success="onSuccessLogin" />
  </div>
</template>

<script>
import RTitle from '@/components/common/Title.vue';
import OAuth from '@/components/login/OAuth.vue';
import LoginMethodSeparator from '@/components/login/LoginMethodSeparator.vue';
import LoginForm from '@/components/login/LoginForm.vue';
import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    RTitle,
    OAuth,
    LoginMethodSeparator,
    LoginForm,
  },
  methods: {
    onSuccessLogin() {
      this.$router.push(ROUTER_PATHS.TARGETING_INFO);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
.title {
  text-align: center;
}
</style>
